import React from "react"
import { graphql, useStaticQuery } from "gatsby"

export default () => {
  const { sanityAbout } = useStaticQuery(graphql`
    query {
      sanityAbout {
        aboutText {
          children {
            text
          }
        }
        aboutHeadline
      }
    }
  `)

  const { aboutHeadline, aboutText } = sanityAbout

  return (
    <section className="about">
      <h2>{aboutHeadline}</h2>
      <div className="about__text">
        {aboutText.map((paragraphPart, index) => {
          const { children } = paragraphPart
          const { text } = children[0]
          if (!text) return null

          return (
            <p
              key={`about-${index}`}
              dangerouslySetInnerHTML={{ __html: text }}
            ></p>
          )
        })}
      </div>
    </section>
  )
}
